/* unplugin-vue-components disabled */import { render } from "./CreatorContestKefuPopup.vue?vue&type=template&id=2203bb4e&scoped=true"
import script from "./CreatorContestKefuPopup.vue?vue&type=script&lang=js"
export * from "./CreatorContestKefuPopup.vue?vue&type=script&lang=js"

import "./CreatorContestKefuPopup.vue?vue&type=style&index=0&id=2203bb4e&lang=less&scoped=true"

import exportComponent from "/Users/hongboyuan/projects/yszn-code/qipaoWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2203bb4e"]])

export default __exports__